import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 4h-6a3 3 0 0 0 -3 3v7","key":"svg-0"}],["path",{"d":"M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4","key":"svg-1"}]]

const IconCornerLeftDownDouble = createReactComponent('outline', 'corner-left-down-double', 'CornerLeftDownDouble', __iconNode);

export default IconCornerLeftDownDouble;